import { QRCodeCanvas } from 'qrcode.react';
import { useParams } from "react-router-dom";


const QRCodeGenerator = () => {
    const { tipo, cnes } = useParams();
    const link = `https://pesquisa.erpsaude.com.br/${cnes}/${tipo}`;

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>QR Code pesquisa de satisfação</h1>
            <QRCodeCanvas
                value={link}
                size={256}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
            />
            <p>Scaneie o código para acessar o link!</p>
        </div>
    );
};

export default QRCodeGenerator;
